import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import config from "../../config";
import { START_LOADER, STOP_LOADER } from "../../redux/actions/types";

const PrivacyPolicy = ({ startLoading, stopLoading }) => {
    const [privacy, setPrivacy] = useState("");

    useEffect(() => {
        startLoading();
        getPages()
            .then(() => {
                stopLoading();
            })
            .catch(() => {
                stopLoading();
            });
    }, []);

    const getPages = async () => {
        try {
            const res = await config.getApi(
                config.services.pages(),
                config.defaultHeaders
            );
            if (res) {
                let findPrivacy = res.response.data.filter(
                    (singlePage) => singlePage.slug === "privacy-policy"
                );
                if (findPrivacy.length > 0) {
                    setPrivacy(findPrivacy[0].content);
                }
                console.log(res);
            }
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <>
            <Header />
            <section>
                <div className="container" style={{ padding: "40px" }}>
                    <div className="row ">
                        <div
                            className="col-md-12"
                            dangerouslySetInnerHTML={{ __html: privacy }}
                        ></div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    startLoading: () => dispatch({ type: START_LOADER }),
    stopLoading: () => dispatch({ type: STOP_LOADER }),
});

export default connect(null, mapDispatchToProps)(PrivacyPolicy);
